export const FiltersMock = [
  {
    id: '0',
    title: 'Categories',
    showMoreLabel: 'Show more',
    showLessLabel: 'Show less',
    value: '',
    items: [
      {
        id: '0',
        label: 'All integrations',
        value: '',
        url: '#',
        active: true
      },
      {
        id: '1',
        label: 'Delivery channels',
        value: 'delivery-channels',
        url: '#',
        active: false
      },
      {
        id: '2',
        label: 'POS systems',
        value: 'pos-systems',
        url: '#',
        active: false
      },
      {
        id: '3',
        label: 'Online ordering',
        value: 'online-ordering',
        url: '#',
        active: false
      },
      {
        id: '4',
        label: 'in-house dining app',
        value: 'in-house-dining-app',
        url: '#',
        active: false
      }
    ]
  },
  {
    id: '1',
    title: 'Countries',
    showMoreLabel: 'Show more',
    showLessLabel: 'Show less',
    value: 'spain',
    items: [
      {
        id: '0',
        label: 'All countries',
        value: '',
        url: '#',
        active: true
      },
      {
        id: '1',
        label: 'Australia',
        value: 'australia',
        url: '#',
        active: false
      },
      {
        id: '2',
        label: 'Belgium',
        value: 'belgium',
        url: '#',
        active: false
      },
      {
        id: '3',
        label: 'Canada',
        value: 'canada',
        url: '#',
        active: false
      },
      {
        id: '4',
        label: 'Germany',
        value: 'germany',
        url: '#',
        active: false
      },
      {
        id: '5',
        label: 'France',
        value: 'france',
        url: '#',
        active: false
      },
      {
        id: '6',
        label: 'Spain',
        value: 'spain',
        url: '#',
        active: false
      },
      {
        id: '7',
        label: 'The Netherlands',
        value: 'the-netherlands',
        url: '#',
        active: false
      },
      {
        id: '8',
        label: 'United states',
        value: 'united-states',
        url: '#',
        active: false
      },
      {
        id: '9',
        label: 'Canada',
        value: 'canada',
        url: '#',
        active: false
      },
      {
        id: '10',
        label: 'Germany',
        value: 'germany',
        url: '#',
        active: false
      }
    ]
  }
]
